/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import Input from "../../../component/inputpm";
import InputLabel from "@mui/material/InputLabel";
import { withTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import classes from "../createPackage/createPackage.module.css";
import Table from "@mui/material/Table";
import Button from "../../../component/button";
import Delete from "@mui/icons-material/Delete";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import KitConfiguration from "./kitConfiguration";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import imageClass from "../packagedSolutionList/packagedSolutionList.module.css";
import Icon from "@mui/material/Icon";
import currencyFormatter from "../../../helper/currencyFormatter";
import ComponentBOM from "../packagedSolution/componentBOM";
import jp from "jsonpath";
import { IconButton, MenuItem, TableContainer, Tooltip } from "@mui/material";
import { DeleteIconNew, PlusIcon } from "../../../component/icons/icons";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const ComponentForm = (props) => {
  const { t } = props;
  const [iteratorList, setIteratorList] = useState([]);
  const [allOtherPricesList, setAllOtherPricesList] = useState([
    {
      name: "DEPOSIT_PRICE",
      value: "DEPOSIT",
      disabled: false,
    },
    {
      name: "USAGE_CHARGE",
      value: "USAGE_CHARGE",
      disabled: false,
    },
    {
      name: "CANCELLATION_PRICE",
      value: "CANCELLATION_PRICE",
      disabled: false,
    },
    {
      name: "SHIFT_PRICE",
      value: "SHIFT_PRICE",
      disabled: false,
    },
    {
      name: "SUSPENSION_PRICE",
      value: "SUSPENSION_PRICE",
      disabled: false,
    },
    {
      name: "REACTIVATION_PRICE",
      value: "REACTIVATION_PRICE",
      disabled: false,
    },
  ]);
  useEffect(() => {
    // if (props.mode === "kit") {
    //     setIteratorList(props.bom)
    // }
    // else {
    //     setIteratorList(props.variants)
    // }
    setIteratorList(props.data.variants);
    if (props.data.otherPrices && props.data.otherPrices.length > 0) {
      props.disableOtherPriceOption(props.data.otherPrices);
    } else {
      props.disableOtherPriceOption();
    }
  }, []);
  return (
    <div>
      {!!props.errLocale && (
        <div className={classes.errorBanner} style={{ marginBottom: "18px" }}>
          <span
            className={classes.errorMessage}
            style={{ color: "color: #D8210E", fontWeight: "600" }}
          >
            {props.errLocale}
          </span>
        </div>
      )}
      <React.Fragment>
        {/* {console.log('iteratorList', iteratorList, props.data.variants)} */}
        <Box
          className="roundCorners"
          style={{ border: "1px solid lightgrey", padding: "1.5rem" }}
        >
          <Grid container spacing={2} style={{ overflow: "hidden" }}>
            <Grid
              item
              style={{ display: "flex", alignItems: "center" }}
              size={{
                xs: 12,
              }}
            >
              <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
                {t("ITEM_DETAILS")}
              </h3>
            </Grid>
          </Grid>
          {/* <Grid item xs={12}>
                        <FormControlLabel
                            style={{marginLeft : '2px'}}
                            control={
                                <Checkbox
                                    checked={props.standAlone}
                                    onChange={event => props.onChange(event)}
                                    name={'standAlone'}
                                    color="primary"
                                    name="standAlone"
                                />
                            }
                            label={t('Sold Stand Alone')}
                        />
                    </Grid> */}
          <Grid container spacing={2} style={{ overflow: "hidden", marginBottom: "1rem" }}>
            {props.enabledModules.INVENTORY &&
              props.enabledModules.INVENTORY.enabled && (
                // props.tenantInfo.tenantId === "ooredoo" || props.tenantInfo.tenantId === "geolocstar" ? '' :
                <>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 2,
                    }}
                  >
                    <FormControlLabel
                      // style={{ marginLeft: '2px' }}
                      disabled={props.readonlyMode}
                      control={
                        <Checkbox
                          checked={props.data.physical}
                          onChange={(event) => props.onChange(event)}
                          name={"physical"}
                          color="primary"
                        />
                      }
                      label={t("PHYSICAL")}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 3,
                    }}
                  >
                    <FormControlLabel
                      // style={{ marginLeft: '2px' }}
                      disabled={props.readonlyMode}
                      control={
                        <Checkbox
                          checked={props.data.sellable}
                          onChange={(event) => props.onChange(event)}
                          name={"sellable"}
                          color="primary"
                        />
                      }
                      label={t("IS_SELLABLE")}
                    />
                  </Grid>

                  <>
                    {
                      props.modules &&
                        props.modules.module_inventory === "enabled" ? (
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 2,
                          }}
                        >
                          <FormControlLabel
                            style={{ marginLeft: "2px" }}
                            disabled={props.readonlyMode}
                            control={
                              <Checkbox
                                checked={props.data.inventoried}
                                onChange={(event) => props.onChange(event)}
                                name={"inventoried"}
                                color="primary"
                              />
                            }
                            label={t("INVENTORIED")}
                          />
                        </Grid>
                      ) : (
                        ""
                      )
                      // !props.isMobile &&
                      // <Grid item xs={12} md={2}></Grid>
                    }

                    {
                      props.modules &&
                        props.modules.module_inventory === "enabled" ? (
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 3,
                          }}
                        >
                          <FormControlLabel
                            style={{ marginLeft: "2px" }}
                            disabled={
                              props.readonlyMode || !props.data.physical
                            }
                            control={
                              <Checkbox
                                checked={props.data.rawMaterial}
                                onChange={(event) => props.onChange(event)}
                                name={"rawMaterial"}
                                color="primary"
                              />
                            }
                            label={t("RAW_MATERIAL")}
                          />
                        </Grid>
                      ) : (
                        ""
                      )
                      // !props.isMobile &&
                      // <Grid item xs={12} md={3}></Grid>
                    }
                  </>
                  {
                    props.modules &&
                      props.modules.module_inventory === "enabled" ? (
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          size={"small"}
                          className={classes.customeSelectLabel}
                        >
                          <InputLabel id="inventoryItemType">
                            {t("SELECT_COMPONENT_ITEM_TYPE") + " *"}
                          </InputLabel>
                          <Select
                            //disabled={props.mode === 'edit'}
                            value={
                              props.data.inventoryItemType
                                ? props.data.inventoryItemType
                                : ""
                            }
                            native
                            label="Item Type *"
                            labelId="inventoryItemType"
                            onChange={(event) => props.onChange(event)}
                            disabled={
                              !props.data.physical || props.readonlyMode
                            }
                            inputProps={{
                              name: "inventoryItemType",
                            }}
                          >
                            <option value="SERIALIZED_ITEM">
                              {t("SERIALIZED")}
                            </option>
                            <option value="NON_SERIALIZED_ITEM">
                              {t("NON_SERIALIZED")}
                            </option>
                          </Select>
                        </FormControl>
                      </Grid>
                    ) : (
                      ""
                    )
                    // !props.isMobile &&
                    // <Grid item xs={12} md={2}></Grid>
                  }
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 3,
                    }}
                  >
                    <FormControlLabel
                      // style={{ marginLeft: '2px' }}
                      disabled={
                        props.readonlyMode ||
                        (iteratorList &&
                          iteratorList.filter((item) => !item.deleteId).length >
                          0)
                      }
                      control={
                        <Checkbox
                          checked={props.data.hasVariants}
                          onChange={(event) => props.onChange(event)}
                          name={"hasVariants"}
                          color="primary"
                        />
                      }
                      label={t("HAS_VARIANTS")}
                    />
                  </Grid>
                </>
              )}
          </Grid>
          <Grid container spacing={2} >
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Input
                // divClass={classes.customDiv}
                error={!!props.err.name}
                helperText={props.err.name}
                name={"name"}
                value={props.data.name}
                onChange={(event) => props.onChange(event)}
                placeholder={t("NAME") + " *"}
                variant={"outlined"}
                size={"small"}
                disabled={props.readonlyMode}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md:
                  props.tenantInfo.tenantId === "ooredoo" ||
                    props.tenantInfo.tenantId === "geolocstar"
                    ? 6
                    : 6,
              }}
            >
              <Input
                error={!!props.err.featureCode}
                helperText={props.err.featureCode}
                name={"featureCode"}
                value={props.data.featureCode}
                onChange={(event) => props.onChange(event)}
                placeholder={t("PRODUCT_CODE") + " *"}
                variant={"outlined"}
                size={"small"}
                type="text"
                disabled={props.readonlyMode}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                error={!!props.err.description}
                helperText={props.err.description}
                name={"description"}
                value={props.data.description}
                onChange={(event) => props.onChange(event)}
                placeholder={t("DESCRIPTION") + " *"}
                variant={"outlined"}
                inputProps={{ rows: 2, cols: 31 }}
                size={"small"}
                disabled={props.readonlyMode}
                multiline={true}
              />
            </Grid>
            {props.data.sellable && props.data.basicDetail && (
              <>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <FormControl
                    variant="outlined"
                    className="custom-select-input"
                    size={"small"}
                    error={!!props.err.categoryId}
                  >
                    <InputLabel id="categoryId">
                      {t("SELECT_PACKAGE_SOLUTION_CATEGORY") + " *"}
                    </InputLabel>
                    <Select
                      native
                      label={t("SELECT_PACKAGE_SOLUTION_CATEGORY") + " *"}
                      labelId="categoryId"
                      value={props.data.basicDetail.categoryId || ""}
                      onChange={(event) => props.onChangeBasicDetail(event)}
                      inputProps={{
                        name: "categoryId",
                        id: "categoryId",
                      }}
                      disabled={props.readonlyMode}
                    >
                      {/* <option value="" disabled>{t('SELECT_CATEGORY')}</option> */}
                      <option value="" disabled></option>
                      {props.categoryList
                        .sort((a, b) => a.categoryName - b.categoryName)
                        .map((opt) => (
                          <option key={opt.categoryId} value={opt.categoryId}>
                            {opt.categoryName}
                          </option>
                        ))}
                    </Select>
                    {props.err.categoryId && (
                      <span
                        style={{
                          color: "#f44336",
                          marginLeft: "0px",
                          fontSize: "0.75rem",
                          marginTop: "4px",
                        }}
                      >
                        {props.err.categoryId}
                      </span>
                    )}
                  </FormControl>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 1,
                  }}
                >
                  <label htmlFor="productMainImage">
                    {props.renderImage && (
                      <>
                        {props.data.basicDetail.productMainImageSource ? (
                          <img
                            width="50"
                            height="50"
                            border="0"
                            src={props.data.basicDetail.productMainImageSource}
                            className={imageClass.cardImage}
                            alt=""
                          />
                        ) : (
                          <img
                            width="50"
                            height="50"
                            border="0"
                            src={placeholderImage}
                            className={imageClass.cardImage}
                            alt=""
                          />
                        )}
                      </>
                    )}
                  </label>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 5,
                  }}
                >
                  <Input
                    inputProps={{ id: "productMainImage" }}
                    name={"productMainImage"}
                    type="file"
                    className="custom-file-input"
                    onChange={(event) =>
                      props.onImageChange(event, "productMainImageSource")
                    }
                    source={props.data.basicDetail.productMainImageSource}
                    disabled={props.readonlyMode}
                  />
                  <label
                    htmlFor="productMainImage"
                    className={"input-file-label"}
                  >
                    <Icon>attach_file</Icon>
                    <label>
                      {props.data.basicDetail.productMainImage ? (
                        props.data.basicDetail.productMainImage
                      ) : (
                        <span className="input-file-placeholder">
                          {t("PRODUCT_MAIN_IMAGE")}{" "}
                        </span>
                      )}
                    </label>
                  </label>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    name={"releaseDate"}
                    type="date"
                    size="small"
                    variant="outlined"
                    label={t("RELEASE_DATE")}
                    value={props.data.releaseDate}
                    onChange={(event) => props.onChange(event)}
                    disabled={props.readonlyMode}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    error={!!props.err.expiryDate}
                    helperText={props.err.expiryDate}
                    name={"expiryDate"}
                    type="date"
                    size="small"
                    variant="outlined"
                    label={t("EXPIRY_DATE")}
                    value={props.data.expiryDate}
                    onChange={(event) => props.onChange(event)}
                    disabled={props.readonlyMode}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Box>
        <Box
          className="roundCorners"
          style={{
            border: "1px solid lightgrey",
            padding: "1.5rem",
            marginTop: ".5rem",
          }}
        >
          <Grid container spacing={2} style={{ overflow: "hidden" }}>
            <Grid
              item
              style={{ display: "flex", alignItems: "center" }}
              size={{
                xs: 12,
              }}
            >
              <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
                {t("PRICE_DETAILS")}
              </h3>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 2,
              }}
            >
              <Input
                // divClass={classes.customDiv}
                error={!!props.err.price}
                helperText={props.err.price}
                name={"price"}
                value={props.data.price}
                onChange={(event) => {
                  if (event.target.value >= 0 || event.target.value === "") {
                    props.onChange(event);
                  }
                }}
                onKeyDown={(event) => {
                  // Intercept the letter "e" (Key code 69) and prevent its default behavior
                  if (event.keyCode === 69) {
                    event.preventDefault();
                  }
                  if (event.key === ",") {
                    event.preventDefault();
                  }
                }}
                placeholder={
                  t("PRICE") + " * : (" + currencyFormatter("", false) + ")"
                }
                type={"number"}
                size={"small"}
                min={1}
                variant={"outlined"}
                disabled={
                  props.readonlyMode ||
                  (iteratorList && iteratorList.length > 0)
                }
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <FormControl
                variant="outlined"
                size={"small"}
                className={classes.customeSelectLabel}
                error={!!props.err.priceType}
              >
                <InputLabel id="priceTypeLabel">
                  {t("SELECT_PRICE_TYPE") + " *"}
                </InputLabel>
                <Select
                  //disabled={props.mode === 'edit'}
                  value={props.data.priceType ? props.data.priceType : ""}
                  native
                  label="select_price_type *"
                  labelId="priceTypeLabel"
                  onChange={(event) => props.onChange(event)}
                  inputProps={{
                    name: "priceType",
                    id: "priceType",
                  }}
                  disabled={props.readonlyMode}
                >
                  <option value=""></option>
                  <option value="NRC">{t("NRC_FULL")}</option>
                  <option value="RC">{t("RC_FULL")}</option>
                  {/* <option value="MRC">{t('MRC_FULL')}</option> */}
                  <option value="NTC">{t("NTC_FULL")}</option>
                </Select>
                {props.err.priceType && (
                  <span
                    style={{
                      color: "#f44336",
                      marginLeft: "0px",
                      fontSize: "0.75rem",
                      marginTop: "4px",
                    }}
                  >
                    {props.err.priceType}
                  </span>
                )}
              </FormControl>
            </Grid>
            {props.data.priceType === "RC" && (
              <>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 2,
                  }}
                >
                  <FormControl
                    variant="outlined"
                    size={"small"}
                    className={classes.customeSelectLabel}
                  >
                    <InputLabel id="priceTenureUOMLabel">
                      {t("SELECT_TENURE_UOM") + " *"}
                    </InputLabel>
                    <Select
                      //disabled={props.mode === 'edit'}
                      value={
                        props.data.priceTenureUOM
                          ? props.data.priceTenureUOM
                          : ""
                      }
                      native
                      label="term UOM *"
                      labelId="priceTenureUOMLabel"
                      onChange={(event) => props.onChange(event)}
                      inputProps={{
                        name: "priceTenureUOM",
                        id: "priceTenureUOM",
                      }}
                      disabled={props.readonlyMode}
                    >
                      <option value="" disabled></option>
                      <option value="TF_day">{t("DAILY")}</option>
                      <option value="TF_wk">{t("WEEKLY")}</option>
                      <option value="TF_mon">{t("MONTHLY")}</option>
                      {/* <option value="TF_qtr">{t('QUARTERLY')}</option> */}
                      <option value="TF_yr">{t("YEARLY")}</option>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 2,
                  }}
                >
                  <Input
                    //divClass={classes.customDiv}
                    error={!!props.err.priceTenure}
                    helperText={props.err.priceTenure}
                    name={"priceTenure"}
                    value={props.data.priceTenure}
                    onChange={(event) => props.onChange(event)}
                    onKeyDown={(event) => {
                      // Intercept the letter "e" (Key code 69) and prevent its default behavior
                      if (event.keyCode === 69) {
                        event.preventDefault();
                      }
                      if (event.key === ",") {
                        event.preventDefault();
                      }
                    }}
                    placeholder={t("TERM_TENURE") + " *"}
                    type={"number"}
                    size={"small"}
                    min={1}
                    variant={"outlined"}
                    disabled={props.readonlyMode}
                  />
                </Grid>
              </>
            )}
            {props.data.priceType === "NTC" && (
              <>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 2,
                  }}
                >
                  <FormControl
                    variant="outlined"
                    size={"small"}
                    className={classes.customeSelectLabel}
                  >
                    <InputLabel id="priceTenureUOMLabel">
                      {t("SELECT_TENURE_UOM") + " *"}
                    </InputLabel>
                    <Select
                      //disabled={props.mode === 'edit'}
                      value={
                        props.data.priceTenureUOM
                          ? props.data.priceTenureUOM
                          : ""
                      }
                      native
                      labelId="priceTenureUOMLabel"
                      onChange={(event) => props.onChange(event)}
                      inputProps={{
                        name: "priceTenureUOM",
                        id: "priceTenureUOM",
                      }}
                      disabled={props.readonlyMode}
                      label={t("SELECT_TENURE_UOM") + " *"}
                    >
                      <option value="" disabled></option>
                      <option value="TF_hr">{t("HOURS")}</option>
                      <option value="TF_day">{t("DAYS")}</option>
                      <option value="TF_wk">{t("WEEKS")}</option>
                      <option value="TF_mon">{t("MONTHS")}</option>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 2,
                  }}
                >
                  <Input
                    //divClass={classes.customDiv}
                    error={!!props.err.priceTenure}
                    helperText={props.err.priceTenure}
                    name={"priceTenure"}
                    value={props.data.priceTenure}
                    onChange={(event) => props.onChange(event)}
                    onKeyDown={(event) => {
                      // Intercept the letter "e" (Key code 69) and prevent its default behavior
                      if (event.keyCode === 69) {
                        event.preventDefault();
                      }
                      if (event.key === ",") {
                        event.preventDefault();
                      }
                    }}
                    placeholder={t("TERM_TENURE") + " *"}
                    type={"number"}
                    size={"small"}
                    min={1}
                    variant={"outlined"}
                    disabled={props.readonlyMode}
                  />
                </Grid>
              </>
            )}
            {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
              props.userPerms.includes("CATALOG_CREATE") ||
              props.userPerms.includes("CATALOG_UPDATE") ||
              props.userPerms.includes("CATALOG_ADMIN")) && (
                <Grid
                  item
                  size={{
                    xs:
                      props.data.priceType === "NTC" ||
                        props.data.priceType === "RC"
                        ? 12
                        : props.isMobile
                          ? 12
                          : 4,
                  }}
                >
                  {props.data.otherPrices &&
                    (props.data.otherPrices.length < 6 ||
                      (props.data.otherPrices.length === 6 &&
                        props.data.otherPrices.some((item) => item.remove))) ? ( // incase length is 4 but entry has a remove parameter
                    props.readonlyMode ||
                      (iteratorList && iteratorList.length > 0) ? (
                      ""
                    ) : (
                      <Button
                        onClick={(event) => props.addOtherPrice()}
                        color="primary"
                      >
                        {t("ADD_OTHER_PRICE")}
                      </Button>
                    )
                  ) : (
                    ""
                  )}
                  {props.readonlyMode ||
                    (props.data.otherPrices &&
                      props.data.otherPrices.length > 0) ? (
                    ""
                  ) : (
                    <>
                      {props.addComponentType === "component" ? (
                        // <Button onClick={event => props.addVariantRow()} style={{ marginLeft: '8px' }} color="primary">{t('ADD_VARIANT')}</Button>
                        ""
                      ) : (
                        <Button
                          onClick={(event) => props.addKitItem()}
                          style={{ marginLeft: "8px" }}
                          color="primary"
                        >
                          {t("ADD_COMPONENT_TO_ASSEMBLY")}
                        </Button>
                      )}
                    </>
                  )}
                </Grid>
              )}
            {props.data.otherPrices && props.data.otherPrices.length > 0 && (
              <>
                {/* <Grid item xs={12} style={{ backgroundColor: '#e1e1e1', marginBottom: '10px' }}>
                                    {props.t('OTHER_PRICES')}
                                </Grid> */}

                {props.data.otherPrices.map((price, pIndex) =>
                  price.remove ? (
                    ""
                  ) : (
                    <>
                      <div style={{ width: '100%' }}></div>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <Input
                          // divClass={classes.customDiv}
                          // error={!!props.err.price}
                          // helperText={props.err.price}
                          name={"price"}
                          value={price.price}
                          onChange={(event) =>
                            props.onChangeOtherPrice(event, pIndex)
                          }
                          onKeyDown={(event) => {
                            // Intercept the letter "e" (Key code 69) and prevent its default behavior
                            if (event.keyCode === 69) {
                              event.preventDefault();
                            }
                            if (event.key === ",") {
                              event.preventDefault();
                            }
                          }}
                          placeholder={
                            t("PRICE") +
                            " : (" +
                            currencyFormatter("", false) +
                            ")"
                          }
                          type={"number"}
                          size={"small"}
                          min={1}
                          variant={"outlined"}
                          disabled={props.readonlyMode}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 3,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          size={"small"}
                          className={classes.customeSelectLabel}
                        >
                          <InputLabel id={"priceTypeLabel" + pIndex}>
                            {t("SELECT_PRICE_TYPE")}
                          </InputLabel>
                          <Select
                            //disabled={props.mode === 'edit'}
                            value={price.priceType ? price.priceType : ""}
                            native
                            labelId={"priceTypeLabel" + pIndex}
                            label={t("SELECT_PRICE_TYPE")}
                            onChange={(event) =>
                              props.onChangeOtherPrice(event, pIndex)
                            }
                            inputProps={{
                              name: "priceType",
                              id: "priceType" + pIndex,
                            }}
                            disabled={props.readonlyMode}
                          >
                            {/* <option value=""></option> */}
                            {props.priceOptions.map((a) => (
                              <option
                                key={a.value}
                                value={a.value}
                                disabled={a.disabled}
                              >
                                {t(a.name)}
                              </option>
                            ))}
                            {/* <option value="DEPOSIT" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'DEPOSIT') > -1 ? true : false}>{t('DEPOSIT_PRICE')}</option>
                                                        <option value="SETUP_FEE" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'SETUP_FEE') > -1 ? true : false}>{t('SETUP_PRICE')}</option>
                                                        <option value="USAGE_CHARGE" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'USAGE_CHARGE') > -1 ? true : false}>{t('USAGE_PRICE')}</option>
                                                        <option value="CANCELLATION_PRICE" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'CANCELLATION_PRICE') > -1 ? true : false}>{t('CANCELLATION_PRICE')}</option> */}
                          </Select>
                          {/* {props.err.priceType && <span style={{ color: '#f44336', marginLeft: '0px', fontSize: '0.75rem', marginTop: '4px' }}>{props.err.priceType}</span>} */}
                        </FormControl>
                      </Grid>
                      {price.priceType === "USAGE_CHARGE" ? (
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 2,
                          }}
                        >
                          <FormControl
                            variant="outlined"
                            size={"small"}
                            className={classes.customeSelectLabel}
                          >
                            <InputLabel id={"priceTenureUOMLabel" + pIndex}>
                              {t("USAGE_CHARGE_UOM")}
                            </InputLabel>
                            <Select
                              //disabled={props.mode === 'edit'}
                              value={
                                price.priceTenureUOM ? price.priceTenureUOM : ""
                              }
                              native
                              labelId={"priceTenureUOMLabel" + pIndex}
                              label={t("USAGE_CHARGE_UOM") + " "}
                              onChange={(event) =>
                                props.onChangeOtherPrice(event, pIndex)
                              }
                              inputProps={{
                                name: "priceTenureUOM",
                                id: "priceTenureUOM" + pIndex,
                              }}
                              disabled={props.readonlyMode}
                            >
                              <option value={"TF_hr"}>{t("HOURLY")}</option>
                              <option value={"TF_day"}>{t("DAILY")}</option>
                              <option value={"TF_wk"}>{t("WEEKLY")}</option>
                              <option value={"TF_mon"}>{t("MONTHLY")}</option>
                              <option value={"TF_yr"}>{t("YEARLY")}</option>
                              <option value={"DATA_MB"}>{t("PER_MB")}</option>
                              <option value={"DATA_GB"}>{t("PER_GB")}</option>
                            </Select>
                          </FormControl>
                        </Grid>
                      ) : (
                        ""
                      )}
                      <Grid
                        item
                        size={{
                          xs: price.priceType === "USAGE_CHARGE" ? 4 : 6,
                        }}
                      >
                        {props.readonlyMode ? (
                          ""
                        ) : (
                          // <Delete onClick={event => props.deleteOtherPrice(pIndex)} />
                          <IconButton
                            className="buttonSecondary"
                            onClick={(event) => props.deleteOtherPrice(pIndex)}
                          >
                            <DeleteIconNew />
                          </IconButton>
                        )}
                      </Grid>
                    </>
                  ),
                )}
              </>
            )}
          </Grid>
        </Box>
        {props.data.hasVariants && (
          <Box
            className="roundCorners"
            style={{
              border: "1px solid lightgrey",
              padding: "1.5rem",
              marginTop: ".5rem",
            }}
          >
            <Grid container spacing={2} style={{ overflow: "hidden" }}>
              <Grid
                item
                style={{ display: "flex", alignItems: "center" }}
                size={{
                  xs: 6,
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
                  {t("VARIANT_DETAILS")}
                </h3>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
                size={{
                  xs: 6,
                }}
              >
                {iteratorList &&
                  iteratorList.filter((item) => !item.deleteId).length > 0 &&
                  (props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                    props.userPerms.includes("CATALOG_CREATE") ||
                    props.userPerms.includes("CATALOG_UPDATE") ||
                    props.userPerms.includes("CATALOG_ADMIN")) &&
                  (props.readonlyMode ||
                    (props.data.otherPrices &&
                      props.data.otherPrices.length > 0) ? (
                    ""
                  ) : (
                    <>
                      {
                        props.addComponentType === "component" ? (
                          <Button
                            onClick={(event) => props.addVariantRow()}
                            style={{ marginLeft: "8px" }}
                            color="primary"
                          >
                            {t("ADD_VARIANT")}
                          </Button>
                        ) : (
                          ""
                        )
                        // <Button onClick={event => props.addKitItem()} style={{ marginLeft: '8px' }} color="primary">{t('ADD_COMPONENT_TO_ASSEMBLY')}</Button>
                      }
                    </>
                  ))}
              </Grid>
              {(!iteratorList ||
                iteratorList.length === 0 ||
                iteratorList.every((item) => item.deleteId)) && (
                  <>
                    <Grid
                      item
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <p>{t("NO_VARIANTS_FOUND")}</p>
                      {(props.userPerms.includes("CATALOG_ADMIN_ALL") ||
                        props.userPerms.includes("CATALOG_CREATE") ||
                        props.userPerms.includes("CATALOG_UPDATE") ||
                        props.userPerms.includes("CATALOG_ADMIN")) &&
                        (props.readonlyMode ||
                          (props.data.otherPrices &&
                            props.data.otherPrices.length > 0) ? (
                          ""
                        ) : (
                          <>
                            {
                              props.addComponentType === "component" ? (
                                <Button
                                  onClick={(event) => props.addVariantRow()}
                                  style={{ marginLeft: "8px" }}
                                  color="primary"
                                >
                                  {t("ADD_VARIANT")}
                                </Button>
                              ) : (
                                ""
                              )
                              // <Button onClick={event => props.addKitItem()} style={{ marginLeft: '8px' }} color="primary">{t('ADD_COMPONENT_TO_ASSEMBLY')}</Button>
                            }
                          </>
                        ))}
                    </Grid>
                  </>
                )}
              {props.addComponentType === "component" ? (
                <>
                  {iteratorList &&
                    iteratorList.length > 0 &&
                    iteratorList.map(
                      (opt, variantIndex) =>
                        !opt.deleteId && (
                          <>
                            <Box
                              className="roundCorners"
                              style={{
                                border: "1px solid lightgrey",
                                padding: "1.5rem",
                                marginBottom: ".5rem",
                                width: '100%',
                              }}
                              key={variantIndex}
                            >
                              <Grid container spacing={2}>
                                <Grid
                                  item
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                  }}
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {/* <span style={{ fontWeight: 'bold' }}>{props.t('VARIANT') + ' #' + (variantIndex + 1)}</span> */}
                                  {props.readonlyMode ? (
                                    ""
                                  ) : (
                                    <>
                                      {(props.userPerms.includes(
                                        "CATALOG_ADMIN_ALL",
                                      ) ||
                                        props.userPerms.includes(
                                          "CATALOG_CREATE",
                                        ) ||
                                        props.userPerms.includes(
                                          "CATALOG_UPDATE",
                                        ) ||
                                        props.userPerms.includes(
                                          "CATALOG_ADMIN",
                                        )) && (
                                          <Button
                                            className="buttonSecondary"
                                            onClick={(event) =>
                                              props.removeVariant(
                                                event,
                                                variantIndex,
                                              )
                                            }
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  marginRight: "5px",
                                                  position: "relative",
                                                  top: ".1rem",
                                                }}
                                              >
                                                <DeleteIconNew />
                                              </span>{" "}
                                              <span
                                                style={{ fontSize: "0.8rem" }}
                                              >
                                                {props.t("DELETE")}
                                              </span>
                                            </div>
                                          </Button>
                                        )}
                                    </>
                                  )}
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 6,
                                  }}
                                >
                                  <Input
                                    error={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      !!props.err.variants[variantIndex]
                                        .variantName
                                    }
                                    helperText={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      props.err.variants[variantIndex]
                                        .variantName
                                    }
                                    name={"name"}
                                    value={opt.name}
                                    onChange={(event) =>
                                      props.onVariantChange(event, variantIndex)
                                    }
                                    disabled={props.readonlyMode}
                                    placeholder={props.t("NAME") + " *"}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 6,
                                  }}
                                >
                                  <Input
                                    error={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      !!props.err.variants[variantIndex]
                                        .variantProductCodeError
                                    }
                                    helperText={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      props.err.variants[variantIndex]
                                        .variantProductCodeError
                                    }
                                    name={"featureCode"}
                                    value={opt.featureCode}
                                    onChange={(event) =>
                                      props.onVariantChange(event, variantIndex)
                                    }
                                    disabled={props.readonlyMode}
                                    placeholder={props.t("FEATURE_CODE") + " *"}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 12,
                                  }}
                                >
                                  <Input
                                    name={"description"}
                                    value={opt.description}
                                    error={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      !!props.err.variants[variantIndex]
                                        .variantDescription
                                    }
                                    helperText={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      props.err.variants[variantIndex]
                                        .variantDescription
                                    }
                                    inputProps={{ rows: 2, cols: 31 }}
                                    onChange={(event) =>
                                      props.onVariantChange(event, variantIndex)
                                    }
                                    disabled={props.readonlyMode}
                                    multiline={true}
                                    placeholder={props.t("DESCRIPTION") + " *"}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 4,
                                  }}
                                >
                                  <Input
                                    name={"price"}
                                    type={"number"}
                                    value={opt.price}
                                    error={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      !!props.err.variants[variantIndex]
                                        .variantPrice
                                    }
                                    helperText={
                                      props.err.variants &&
                                      props.err.variants.length > 0 &&
                                      props.err.variants[variantIndex]
                                        .variantPrice
                                    }
                                    onChange={(event) =>
                                      props.onVariantChange(event, variantIndex)
                                    }
                                    onKeyDown={(event) => {
                                      // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                      if (event.keyCode === 69) {
                                        event.preventDefault();
                                      }
                                      if (event.key === ",") {
                                        event.preventDefault();
                                      }
                                    }}
                                    disabled={props.readonlyMode}
                                    placeholder={props.t("PRICE") + " *"}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  {props.readonlyMode ? (
                                    ""
                                  ) : (
                                    <>
                                      {/* <DeleteIconNew onClick={event => props.removeVariant(event, variantIndex)} /> */}
                                      {(props.userPerms.includes(
                                        "CATALOG_ADMIN_ALL",
                                      ) ||
                                        props.userPerms.includes(
                                          "CATALOG_CREATE",
                                        ) ||
                                        props.userPerms.includes(
                                          "CATALOG_UPDATE",
                                        ) ||
                                        props.userPerms.includes(
                                          "CATALOG_ADMIN",
                                        )) && (
                                          <>
                                            <Button
                                              style={{ marginRight: "5px" }}
                                              onClick={(event) =>
                                                props.addOtherPricesOnVariant(
                                                  event,
                                                  variantIndex,
                                                )
                                              }
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    marginRight: "5px",
                                                    position: "relative",
                                                    top: ".1rem",
                                                  }}
                                                >
                                                  <PlusIcon />
                                                </span>{" "}
                                                <span
                                                  style={{ fontSize: "0.8rem" }}
                                                >
                                                  {props.t("ADD_OTHER_PRICE")}
                                                </span>
                                              </div>
                                            </Button>
                                          </>
                                        )}
                                    </>
                                  )}
                                </Grid>
                                {opt.otherPrices &&
                                  opt.otherPrices.length > 0 && (
                                    <Grid item container spacing={2}>
                                      {opt.otherPrices &&
                                        opt.otherPrices.length > 0 && (
                                          <>
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                width: "100%",
                                                padding: "0rem .5rem",
                                              }}
                                            >
                                              {props.t("OTHER_PRICES")}
                                            </p>
                                            {opt.otherPrices.map(
                                              (price, pIndex) =>
                                                price.remove ? (
                                                  ""
                                                ) : (
                                                  <>
                                                    <Grid
                                                      item
                                                      key={pIndex}
                                                      size={{
                                                        xs: 12,
                                                        md: 2,
                                                      }}
                                                    >
                                                      <Input
                                                        name={"price"}
                                                        value={price.price}
                                                        onChange={(event) =>
                                                          props.onChangeOtherPriceVariant(
                                                            event,
                                                            pIndex,
                                                            variantIndex,
                                                          )
                                                        }
                                                        onKeyDown={(event) => {
                                                          // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                                          if (
                                                            event.keyCode === 69
                                                          ) {
                                                            event.preventDefault();
                                                          }
                                                          if (
                                                            event.key === ","
                                                          ) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        placeholder={
                                                          t("PRICE") +
                                                          " : (" +
                                                          currencyFormatter(
                                                            "",
                                                            false,
                                                          ) +
                                                          ")"
                                                        }
                                                        type={"number"}
                                                        size={"small"}
                                                        min={1}
                                                        variant={"outlined"}
                                                        disabled={
                                                          props.readonlyMode
                                                        }
                                                      />
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      size={{
                                                        xs: 12,
                                                        md: 4,
                                                      }}
                                                    >
                                                      <FormControl
                                                        variant="outlined"
                                                        size={"small"}
                                                        className={
                                                          classes.customeSelectLabel
                                                        }
                                                      >
                                                        <InputLabel
                                                          id={
                                                            "priceTypeLabel" +
                                                            pIndex
                                                          }
                                                        >
                                                          {t(
                                                            "SELECT_PRICE_TYPE",
                                                          )}
                                                        </InputLabel>
                                                        <Select
                                                          value={
                                                            price.priceType
                                                              ? price.priceType
                                                              : ""
                                                          }
                                                          native
                                                          labelId={
                                                            "priceTypeLabel" +
                                                            pIndex
                                                          }
                                                          label={t(
                                                            "SELECT_PRICE_TYPE",
                                                          )}
                                                          onChange={(event) =>
                                                            props.onChangeOtherPriceVariant(
                                                              event,
                                                              pIndex,
                                                              variantIndex,
                                                            )
                                                          }
                                                          inputProps={{
                                                            name: "priceType",
                                                            id:
                                                              "priceType" +
                                                              pIndex,
                                                          }}
                                                          disabled={
                                                            props.readonlyMode
                                                          }
                                                        >
                                                          {/* <option value=""></option> */}
                                                          {opt.priceOptions.map(
                                                            (a) => (
                                                              <option
                                                                key={a.value}
                                                                value={a.value}
                                                                disabled={
                                                                  a.disabled
                                                                }
                                                              >
                                                                {t(a.name)}
                                                              </option>
                                                            ),
                                                          )}
                                                          {/* <option value="DEPOSIT" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'DEPOSIT') > -1 ? true : false}>{t('DEPOSIT_PRICE')}</option>
                                                                <option value="SETUP_FEE" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'SETUP_FEE') > -1 ? true : false}>{t('SETUP_PRICE')}</option>
                                                                <option value="USAGE_CHARGE" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'USAGE_CHARGE') > -1 ? true : false}>{t('USAGE_PRICE')}</option>
                                                                <option value="CANCELLATION_PRICE" disabled={props.data.otherPrices.findIndex(x => x.priceType === 'CANCELLATION_PRICE') > -1 ? true : false}>{t('CANCELLATION_PRICE')}</option> */}
                                                        </Select>
                                                        {/* {props.err.priceType && <span style={{ color: '#f44336', marginLeft: '0px', fontSize: '0.75rem', marginTop: '4px' }}>{props.err.priceType}</span>} */}
                                                      </FormControl>
                                                    </Grid>
                                                    {price.priceType ===
                                                      "USAGE_CHARGE" ? (
                                                      <Grid
                                                        item
                                                        size={{
                                                          xs: 12,
                                                          md: 4,
                                                        }}
                                                      >
                                                        <FormControl
                                                          variant="outlined"
                                                          size={"small"}
                                                          className={
                                                            classes.customeSelectLabel
                                                          }
                                                        >
                                                          <InputLabel
                                                            id={
                                                              "priceTenureUOMLabel" +
                                                              pIndex
                                                            }
                                                          >
                                                            {t(
                                                              "USAGE_CHARGE_UOM",
                                                            )}
                                                          </InputLabel>
                                                          <Select
                                                            //disabled={props.mode === 'edit'}
                                                            value={
                                                              price.priceTenureUOM
                                                                ? price.priceTenureUOM
                                                                : ""
                                                            }
                                                            native
                                                            labelId={
                                                              "priceTenureUOMLabel" +
                                                              pIndex
                                                            }
                                                            label={t(
                                                              "USAGE_CHARGE_UOM",
                                                            )}
                                                            onChange={(event) =>
                                                              props.onChangeOtherPriceVariant(
                                                                event,
                                                                pIndex,
                                                                variantIndex,
                                                              )
                                                            }
                                                            inputProps={{
                                                              name: "priceTenureUOM",
                                                              id:
                                                                "priceTenureUOM" +
                                                                pIndex,
                                                            }}
                                                            disabled={
                                                              props.readonlyMode
                                                            }
                                                          >
                                                            <option
                                                              value={"TF_hr"}
                                                            >
                                                              {t("HOURLY")}
                                                            </option>
                                                            <option
                                                              value={"TF_day"}
                                                            >
                                                              {t("DAILY")}
                                                            </option>
                                                            <option
                                                              value={"TF_wk"}
                                                            >
                                                              {t("WEEKLY")}
                                                            </option>
                                                            <option
                                                              value={"TF_mon"}
                                                            >
                                                              {t("MONTHLY")}
                                                            </option>
                                                            <option
                                                              value={"TF_yr"}
                                                            >
                                                              {t("YEARLY")}
                                                            </option>
                                                            <option
                                                              value={"DATA_MB"}
                                                            >
                                                              {t("PER_MB")}
                                                            </option>
                                                            <option
                                                              value={"DATA_GB"}
                                                            >
                                                              {t("PER_GB")}
                                                            </option>
                                                          </Select>
                                                        </FormControl>
                                                      </Grid>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <Grid
                                                      item
                                                      size={{
                                                        xs:
                                                          price.priceType ===
                                                            "USAGE_CHARGE"
                                                            ? 2
                                                            : 6,
                                                      }}
                                                    >
                                                      {props.readonlyMode ? (
                                                        ""
                                                      ) : (
                                                        <IconButton
                                                          className="buttonSecondary"
                                                          onClick={(event) =>
                                                            props.deleteOtherPriceOnVariant(
                                                              event,
                                                              pIndex,
                                                              variantIndex,
                                                            )
                                                          }
                                                        >
                                                          <DeleteIconNew />
                                                        </IconButton>
                                                      )}
                                                    </Grid>
                                                  </>
                                                ),
                                            )}
                                          </>
                                        )}
                                    </Grid>
                                  )}
                              </Grid>
                            </Box>
                          </>
                        ),
                    )}
                </>
              ) : (
                <KitConfiguration
                  data={props.data}
                  expandKitComponentsTable={props.expandKitComponentsTable}
                  removeKit={props.removeKit}
                  screen={"component"}
                  changeChildrenData={props.changeChildrenData}
                  setMinQuantityValue={props.setMinQuantityValue}
                  readonlyMode={props.readonlyMode}
                />
              )}
              {props.data.bom && props.data.bom.length > 0 && (
                <TableContainer>
                  <Table>
                    <TableBody>
                      <ComponentBOM
                        index={props.data.id}
                        readonlyMode={props.readonlyMode}
                        data={props.data}
                        expandVariants={true}
                        mode={"offering"}
                        changeBomProductsData={props.changeBomProductsData}
                      />
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Grid>
          </Box>
        )}
      </React.Fragment>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    enabledModules: state.auth.enabledModules,
    tenantInfo: state.auth.tenantInfo,
    userPerms: state.auth.userPerms,
  };
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ComponentForm),
);
